import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, Box } from '@mui/material';

const SelectFilter = ({ label, items, keyField, labelField, mapping, searchFilter, setSearchFilter }) => {
  const handleChange = (event) => {
    const value = event.target.value.map(item => item[keyField]).filter(val => val !== null && val !== undefined);
    setSearchFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      const keys = mapping.split('.');
      let current = newFilter;

      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value;
        } else {
          if (!current[key]) {
            current[key] = {};
          }
          current = current[key];
        }
      });

      return newFilter;
    });
  };

  const selectedValues = mapping.split('.').reduce((acc, key) => {
    return acc ? acc[key] : [];
  }, searchFilter) || [];

  return (
    <Box sx={{ minWidth: 150, marginBottom: 2, mr : 2 }}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          value={items.filter(item => selectedValues.includes(item[keyField]))}
          onChange={handleChange}
          renderValue={(selected) => selected.map(item => item[labelField]).join(', ')}
        >
          {items.sort((a,b) => a[labelField].localeCompare(b[labelField])).map((item) => (
            <MenuItem key={item[keyField]} value={item}>
              <Checkbox checked={selectedValues.indexOf(item[keyField]) > -1} />
              <ListItemText primary={item[labelField]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectFilter;
